export const ROUTES = {
	ROOMS: "rooms",
	MARKET: "market",
	INVENTORY: "inventory",
	MARKET_PAYMENT_SUCCESSFUL: "market/payment-successful",
	Leaderboard: "leaderboard",

	LANDING: "",
	USAGE_RULES: "usage-rules",
	PRIVACY_POLICY: "privacy-policy",
	PUBLIC_OFFER: "public-offer",

	GUIDE_ROOMS: "guides/rooms",
	GUIDE_RULES: "guides/rules",
	GUIDE_APPLICATION: "guides/application",

	AUTH: "auth/*",
	PASSWORD_RESET: "password-reset/*",
	EMAIL_RESET: "email-reset",
	UNSUBSCRIBE: "unsubscribe",
	ACCOUNT_DELETION: "auth/account-deletion",

	SETTINGS: "settings",
	SETTINGS_REFERRAL: "settings?tab=referral",
	SETTINGS_RATING: "settings?tab=rating",
	SETTINGS_SUBSCRIPTION: "settings?tab=subscription",
	CAPITALISTO_PLUS: "capitalisto-plus",
	PAYMENT_SUCCESSFUL: "capitalisto-plus/payment-successful",

	LOST: "*",

	GENERAL_PROFILE: (id: number) => `user/${id}`,
	GENERAL_PROFILE_TEMPLATE: "user/:id",
	USER_INVENTORY: (id: number) => `user/${id}/inventory`,
	USER_INVENTORY_TEMPLATE: "user/:id/inventory",
	MY_PROFILE: (id: string) => `user/${id}`,
	PROFILE: "profile",

	FRIENDS: "friends",
	USER_SEARCH: "friends/search",
	SOCIAL: "social",
	LEADERBOARD: "leaderboard",

	GAME: "game",
	ROOT_REDIRECT: "/",

	// admin
	ADMIN: "admin",
	ADMIN_ROOMS: "admin/rooms",
	ADMIN_GAMES: "admin/games",
	ADMIN_REPORTS: "admin/reports",
	ADMIN_EMAILS: "admin/emails",
	ADMIN_COMPONENTS: "admin/components",
	ADMIN_UI: "admin/ui",
	ADMIN_USERS: "admin/users",
	ADMIN_COSMETICS: "admin/cosmetics",
	ADMIN_CITIES: "admin/cities",
} as const;

export type RoutePaths = (typeof ROUTES)[keyof typeof ROUTES];
